import React, { FC } from "react";
import { TextField } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomLabelInput from "@components/CustomLabelInput";

const EmailForm: FC<{ form: UseFormReturn<{ email: string }> }> = ({
  form,
}) => {
  const {
    register,
    formState: { disabled, errors },
  } = form;
  const { t } = useTranslation();

  return (
    <div>
      <CustomLabelInput
        label={t("myAccount.emailInput.label")}
        id="accountEmail"
      >
        <TextField
          {...register("email")}
          id="accountEmail"
          error={!!errors?.email}
          type="email"
          size="small"
          variant="outlined"
          fullWidth
          placeholder={t("myAccount.emailInput.placeholder")}
          disabled={disabled}
        />
      </CustomLabelInput>
    </div>
  );
};

export default EmailForm;
